var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQuestionMark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 39,
    viewBox: "0 0 39 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 39,
    height: 39,
    rx: 19.5,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.8213 22.864V21.808C17.8213 21.3387 17.9093 20.8987 18.0853 20.488C18.276 20.0773 18.5033 19.7327 18.7673 19.454C19.046 19.1607 19.3393 18.86 19.6473 18.552C19.97 18.2293 20.2633 17.9433 20.5273 17.694C20.806 17.43 21.0333 17.122 21.2093 16.77C21.4 16.4033 21.4953 16.022 21.4953 15.626C21.4953 14.9953 21.2973 14.482 20.9013 14.086C20.5053 13.6753 19.9553 13.47 19.2513 13.47C18.21 13.47 17.4326 14.02 16.9193 15.12L15.0273 14.262C15.2913 13.4993 15.7753 12.8173 16.4793 12.216C17.198 11.6147 18.1586 11.314 19.3613 11.314C20.74 11.314 21.8473 11.71 22.6833 12.502C23.534 13.2793 23.9593 14.2767 23.9593 15.494C23.9593 16.1247 23.8273 16.7113 23.5633 17.254C23.2993 17.7967 22.984 18.2513 22.6173 18.618C22.2506 18.9847 21.8766 19.3367 21.4953 19.674C21.1286 19.9967 20.8133 20.356 20.5493 20.752C20.2853 21.1333 20.1533 21.5293 20.1533 21.94V22.864H17.8213ZM17.9093 26.846C17.6013 26.538 17.4473 26.1713 17.4473 25.746C17.4473 25.3207 17.6013 24.954 17.9093 24.646C18.2173 24.338 18.584 24.184 19.0093 24.184C19.4346 24.184 19.8013 24.338 20.1093 24.646C20.4173 24.954 20.5713 25.3207 20.5713 25.746C20.5713 26.1713 20.4173 26.538 20.1093 26.846C19.8013 27.1393 19.4346 27.286 19.0093 27.286C18.584 27.286 18.2173 27.1393 17.9093 26.846Z",
    fill: "#777777"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionMark);
export default __webpack_public_path__ + "static/media/question-mark.fe92e04a591d10d10fc6a0dc13a782d6.svg";
export { ForwardRef as ReactComponent };